import React, { Component } from "react";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import {
    createStyles,
    Text,
    Avatar,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image,
    Group,
    Card,
    Button
} from '@mantine/core';

import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp,
    IconCheck,
    IconX
} from '@tabler/icons';

import pagani from '../assets/pagani.jpg';

const useStyles = createStyles((theme) => ({
    msg: {
        textAlign: 'center'
    }
}));


//needed:doc only a message property is needed
//export function ConfirmationCardBase({message}){
const ConfirmationCardBase = ({message}) => {
    const { classes } = useStyles();
    return (
        <>
            <Card shadow="sm" p="lg" radius="md">
                <Card.Section>
                    <Text size="lg" className={classes.msg}>
                        {message}
                    </Text>
                </Card.Section>
                <br/>
                <Group position="apart" mt="md" mb="xs">
                    <Button
                        color="green"
                        leftIcon={<IconCheck size={35} stroke={2.0}/>}
                    >
                    YES
                    </Button>
                    <Button
                        color="red"
                        leftIcon={<IconX size={35} stroke={2.0}/>}
                    >
                    NO
                    </Button>
                </Group>
            </Card>
        </>
    )
};
export default ConfirmationCardBase;
